// src/AddedToCartModal.tsx

import React, { useEffect } from 'react';
import { Producto } from './types';

interface AddedToCartModalProps {
    producto: Producto | null;
    onClose: () => void;
}

const AddedToCartModal: React.FC<AddedToCartModalProps> = ({ producto, onClose }) => {
    
    // Efecto para auto-cerrar el modal después de 3 segundos
    useEffect(() => {
        if (producto) {
            const timer = setTimeout(() => {
                onClose();
            }, 3000); // 3 segundos
            
            // Limpia el timer si el componente se desmonta o el producto cambia
            return () => clearTimeout(timer);
        }
    }, [producto, onClose]);

    if (!producto) return null;

    return (
        // Overlay
        <div 
            className="fixed inset-0 bg-black bg-opacity-60 z-50 flex justify-center items-center p-4" 
            onClick={onClose}
        >
            {/* Contenedor del Modal */}
            <div 
                className="bg-white w-full max-w-md p-6 transform transition-all duration-300 shadow-2xl animate-fadeInUp"
                onClick={(e) => e.stopPropagation()} // Evita que el clic dentro del modal lo cierre
            >
                {/* Icono de Éxito */}
                <div className="flex justify-center mb-4">
                    <svg className="w-16 h-16 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                </div>

                <h2 className="text-2xl font-bold text-gray-900 text-center mb-2">¡Añadido al Carrito!</h2>
                
                <p className="text-center text-gray-600 mb-6">
                    El producto <span className="font-semibold">{producto.nombre}</span> ha sido añadido.
                </p>

                {/* Resumen del Producto */}
                <div className="flex items-center space-x-4 p-4 bg-gray-50 border mb-6">
                    <img src={producto.imgUrl} alt={producto.nombre} className="w-16 h-16 object-cover" />
                    <div className="flex-1 min-w-0">
                        <p className="text-lg font-semibold text-gray-900 truncate">{producto.nombre}</p>
                        <p className="text-lg font-bold text-yellow-600">${producto.precio.toLocaleString('es-ES')}</p>
                    </div>
                </div>

                {/* Botón de Cerrar */}
                <button 
                    onClick={onClose}
                    className="w-full bg-yellow-600 text-white font-bold py-3 hover:bg-yellow-700 transition duration-200 text-lg shadow-lg"
                >
                    Entendido
                </button>
            </div>
        </div>
    );
};

export default AddedToCartModal;